import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginRedirectModal from "./LoginRedirectModal";
import PricingPage from "./PricingPage";
import Logo from "@/components/ui/Logo";

const BRAND = "Conexo POS";

const PROBLEM_ITEMS = [
    { icon: "📋", text: "Comandas en papel que se pierden o llegan mal a cocina" },
    { icon: "💸", text: "Comisiones abusivas de las plataformas de delivery" },
    { icon: "📊", text: "Sin datos reales de ventas ni ocupación de mesas" },
    { icon: "🖨️", text: "Software de caja anticuado, caro de mantener y sin soporte" },
];

const SOLUTION_ITEMS = [
    { icon: "🖥️", title: "TPV Táctil OS", desc: "Sistema operativo intuitivo. Funciona en tablet, PC y pantallas touch." },
    { icon: "🍳", title: "Kitchen Screen", desc: "Pedidos llegan en segundos. Sin papel. Control total de tiempos." },
    { icon: "📱", title: "QR en Mesa", desc: "El cliente pide desde su móvil. Evita esperas y rota mesas más rápido." },
    { icon: "🚴", title: "Delivery Hub", desc: "Red de riders propia. Tracking en vivo y asignación automática." },
    { icon: "🔗", title: "Integración Total", desc: "Glovo, Uber Eats y Just Eat sincronizados en una sola pantalla." },
    { icon: "🏢", title: "SaaS Escalable", desc: "Gestiona múltiples locales y escala tu negocio con datos reales." },
];

const PROMISE_ITEMS = [
    { stat: "0€", label: "Comisiones por pedido" },
    { stat: "3 min", label: "Tiempo de configuración" },
    { stat: "∞", label: "Pedidos incluidos" },
    { stat: "7 días", label: "Trial gratuito" },
];

export default function LandingPage() {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (
        <div style={s.root} className="page-fade-in">
            <LoginRedirectModal open={modalOpen} onClose={() => setModalOpen(false)} />

            {/* ── NAV ── */}
            <nav style={s.nav}>
                <div style={s.navInner}>
                    <Logo size={isMobile ? 20 : 24} />

                    {/* Desktop links */}
                    {!isMobile && (
                        <div style={s.navLinks}>
                            <a href="#problema" style={s.navLink}>Por qué</a>
                            <a href="#solucion" style={s.navLink}>Funciones</a>
                        </div>
                    )}

                    {/* Desktop CTA */}
                    {!isMobile && (
                        <div style={s.navActions}>
                            <button onClick={() => setModalOpen(true)} className="btn-premium" style={{ background: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-soft)', padding: '0.5rem 1.25rem', fontSize: '0.9rem' }}>
                                Acceder
                            </button>
                            <button id="nav-demo" onClick={() => navigate("/demo")} className="btn-premium" style={{ background: 'rgba(59, 130, 246, 0.1)', color: 'var(--primary)', border: '1px solid rgba(59, 130, 246, 0.2)', padding: '0.5rem 1.25rem', fontSize: '0.9rem' }}>
                                Ver demo
                            </button>
                            <button id="nav-cta" onClick={() => navigate("/onboarding")} className="btn-premium" style={{ padding: '0.5rem 1.25rem', fontSize: '0.9rem' }}>
                                Crear restaurante
                            </button>
                        </div>
                    )}

                    {/* Mobile hamburger */}
                    {isMobile && (
                        <button
                            onClick={() => setMenuOpen(!menuOpen)}
                            style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', padding: '0.5rem', marginLeft: 'auto', display: 'flex', flexDirection: 'column', gap: '5px' }}
                            aria-label="Menú"
                        >
                            <span style={{ display: 'block', width: '24px', height: '2px', background: menuOpen ? 'var(--primary)' : 'white', transition: 'all 0.3s', transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
                            <span style={{ display: 'block', width: '24px', height: '2px', background: menuOpen ? 'var(--primary)' : 'white', transition: 'all 0.3s', opacity: menuOpen ? 0 : 1 }} />
                            <span style={{ display: 'block', width: '24px', height: '2px', background: menuOpen ? 'var(--primary)' : 'white', transition: 'all 0.3s', transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
                        </button>
                    )}
                </div>

                {/* Mobile dropdown menu */}
                {isMobile && menuOpen && (
                    <div style={{ background: 'rgba(2,6,23,0.98)', backdropFilter: 'blur(20px)', borderTop: '1px solid var(--border-soft)', padding: '1.5rem' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.5rem' }}>
                            <a href="#problema" style={{ ...s.navLink, fontSize: '1rem' }} onClick={() => setMenuOpen(false)}>Por qué Conexo POS</a>
                            <a href="#solucion" style={{ ...s.navLink, fontSize: '1rem' }} onClick={() => setMenuOpen(false)}>Funciones</a>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                            <button onClick={() => { setModalOpen(true); setMenuOpen(false); }} className="btn-premium" style={{ background: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-soft)', width: '100%' }}>
                                Acceder a mi TPV
                            </button>
                            <button onClick={() => { navigate("/demo"); setMenuOpen(false); }} className="btn-premium" style={{ background: 'rgba(59,130,246,0.1)', color: 'var(--primary)', border: '1px solid rgba(59,130,246,0.2)', width: '100%' }}>
                                Ver demo
                            </button>
                            <button onClick={() => { navigate("/onboarding"); setMenuOpen(false); }} className="btn-premium" style={{ width: '100%' }}>
                                Crear mi restaurante →
                            </button>
                        </div>
                    </div>
                )}
            </nav>

            {/* ── HERO ── */}
            <section style={{ ...s.hero, flexDirection: isMobile ? 'column' : 'row', padding: isMobile ? '4rem 1.25rem 3rem' : '6rem 1.5rem 5rem', gap: isMobile ? '3rem' : '4rem' }}>
                <div style={s.heroGlow} />
                <div style={{ ...s.heroContent, textAlign: isMobile ? 'center' : 'left' }}>
                    <div style={s.heroBadge} className="glass-effect">
                        🏆 El sistema operativo de Conexo POS
                    </div>
                    <h1 style={{ ...s.heroTitle, fontSize: isMobile ? 'clamp(2rem,8vw,2.8rem)' : 'clamp(2.5rem,5vw,4rem)' }}>
                        El sistema operativo<br />
                        <span style={s.heroAccent}>para restaurantes.</span>
                    </h1>
                    <p style={{ ...s.heroSub, fontSize: isMobile ? '1rem' : '1.2rem' }}>
                        TPV, cocina, delivery propio y red de riders en una sola plataforma.<br />
                        Toma el control total de tu negocio.
                    </p>
                    <div style={{ ...s.heroCtas, justifyContent: isMobile ? 'center' : 'flex-start' }}>
                        <button id="hero-demo" onClick={() => navigate("/demo")} className="btn-premium" style={{ background: 'rgba(255,255,255,0.05)', color: 'white', border: '1px solid var(--border-soft)' }}>
                            Ver demo
                        </button>
                        <button id="hero-start" onClick={() => navigate("/onboarding")} className="btn-premium">
                            Crear mi restaurante
                        </button>
                    </div>
                    <p style={s.heroNote}>Sin tarjeta. Configura en minutos.</p>
                </div>

                {/* Dashboard preview — hidden on very small screens */}
                {!isMobile && (
                    <div style={s.heroMock} className="glass-effect card-hover">
                        <div style={s.mockBar}>
                            <span style={s.dot} /><span style={{ ...s.dot, background: "#fbbf24" }} /><span style={{ ...s.dot, background: "#34d399" }} />
                            <span style={s.mockTitle}>Conexo POS — Panel Admin</span>
                        </div>
                        <div style={s.mockBody}>
                            <div style={s.mockSidebar}>
                                {["📦 Pedidos", "🍳 Cocina", "📊 Caja", "🪑 Mesas", "⚙️ Config"].map((i, k) => (
                                    <div key={k} style={{ ...s.mockItem, ...(k === 0 ? s.mockItemActive : {}) }}>{i}</div>
                                ))}
                            </div>
                            <div style={s.mockContent}>
                                <div style={s.mockCard} className="glass-effect">
                                    <div style={{ ...s.mockStat, color: "#fff" }}>€ 3,842</div>
                                    <div style={s.mockLabel}>Facturación hoy</div>
                                </div>
                                <div style={s.mockCard} className="glass-effect">
                                    <div style={{ ...s.mockStat, color: "#34d399" }}>94</div>
                                    <div style={s.mockLabel}>Pedidos completados</div>
                                </div>
                                <div style={s.mockCard} className="glass-effect">
                                    <div style={{ ...s.mockStat, color: "#EAB308" }}>12</div>
                                    <div style={s.mockLabel}>Mesas activas</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>

            {/* ── PROMESAS ── */}
            <section style={s.promisesSection}>
                <div style={s.container}>
                    <div style={{ ...s.promisesGrid, gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: isMobile ? '1.5rem' : '2rem' }}>
                        {PROMISE_ITEMS.map((p, i) => (
                            <div key={i} style={s.promiseCard} className="card-hover">
                                <div style={{ ...s.promiseStat, fontSize: isMobile ? '2rem' : '2.5rem' }}>{p.stat}</div>
                                <div style={{ ...s.promiseLabel, fontSize: isMobile ? '0.8rem' : '0.9rem' }}>{p.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── PROBLEMA ── */}
            <section id="problema" style={s.section}>
                <div style={s.container}>
                    <div style={s.sectionHeader}>
                        <span style={s.pill}>😤 El problema</span>
                        <h2 style={{ ...s.sectionTitle, fontSize: isMobile ? '1.75rem' : '2.5rem' }}>¿Reconoces alguna de estas situaciones?</h2>
                    </div>
                    <div style={{ ...s.problemGrid, gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(260px,1fr))' }}>
                        {PROBLEM_ITEMS.map((p, i) => (
                            <div key={i} style={s.problemCard} className="glass-effect card-hover">
                                <span style={s.problemIcon}>{p.icon}</span>
                                <p style={s.problemText}>{p.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── SOLUCIÓN ── */}
            <section id="solucion" style={{ ...s.section, background: "var(--bg-deep)", padding: isMobile ? '4rem 1.25rem' : '7rem 1.5rem' }}>
                <div style={s.container}>
                    <div style={s.sectionHeader}>
                        <span style={{ ...s.pill, background: "rgba(59,130,246,0.1)", borderColor: "rgba(59,130,246,0.2)", color: "var(--primary)" }}>
                            ✅ La solución
                        </span>
                        <h2 style={{ ...s.sectionTitle, fontSize: isMobile ? '1.75rem' : '2.5rem' }}>Todo lo que necesitas. Nada que no uses.</h2>
                    </div>
                    <div style={{ ...s.solutionGrid, gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px,1fr))' }}>
                        {SOLUTION_ITEMS.map((item, i) => (
                            <div key={i} style={s.solutionCard} className="glass-effect card-hover">
                                <div style={s.solutionIcon}>{item.icon}</div>
                                <h3 style={s.solutionTitle}>{item.title}</h3>
                                <p style={s.solutionDesc}>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── PRICING ── */}
            {/* <PricingPage onCtaClick={(slug, isYearly) => navigate(`/onboarding?plan=${slug || 'pro'}&cycle=${isYearly ? 'yearly' : 'monthly'}`)} /> */}

            {/* ── INSTALACIÓN ── */}
            <section style={{ ...s.section, background: "rgba(15,23,42,0.3)" }}>
                <div style={s.container}>
                    <div className="glass-effect" style={{ ...s.noComCard, padding: '3rem', border: '1px dashed rgba(59,130,246,0.3)' }}>
                        <h2 style={{ color: '#fff', fontSize: '1.8rem', fontWeight: "800", marginBottom: '1rem' }}>⚙️ Instalación opcional desde 300€</h2>
                        <p style={{ color: 'var(--text-soft)', marginBottom: '2rem' }}>
                            Nosotros nos encargamos de todo para que tú solo te preocupes de cocinar.<br />
                            Configuración total, carga de menú, conexión de impresoras y entrenamiento de personal.
                        </p>
                        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', fontSize: '0.8rem', color: '#64748b' }}>
                            <span>✓ Setup inicial</span>
                            <span>✓ Carga de carta</span>
                            <span>✓ Training</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── PRUEBA GRATIS BANNER ── */}
            <section style={{ background: 'var(--primary)', padding: '1.5rem', textAlign: 'center' }}>
                <h3 style={{ color: '#fff', fontWeight: "900", margin: 0, fontSize: '1.2rem' }}>
                    🚀 Prueba Conexo POS gratis durante 7 días. <button onClick={() => navigate("/onboarding")} style={{ background: '#fff', color: 'var(--primary)', border: 'none', padding: '0.5rem 1.5rem', borderRadius: '99px', marginLeft: '1rem', fontWeight: "900", cursor: 'pointer' }}>Empezar ahora</button>
                </h3>
            </section>

            {/* ── SIN COMISIONES ── */}
            <section style={{ ...s.noComSection, padding: isMobile ? '4rem 1.25rem' : '6rem 1.5rem' }}>
                <div style={s.container}>
                    <div style={{ ...s.noComCard, padding: isMobile ? '2rem 1.5rem' : '4rem' }} className="glass-effect">
                        <h2 style={{ ...s.noComTitle, fontSize: isMobile ? '1.6rem' : '2.5rem' }}>Sin comisiones por pedido. Siempre.</h2>
                        <p style={{ ...s.noComSub, fontSize: isMobile ? '0.95rem' : '1.1rem' }}>
                            En Conexo POS pagas solo la suscripción mensual. Cada pedido que entra es 100% tuyo.
                            Sin sorpresas. Sin letra pequeña.
                        </p>
                        <div style={{ ...s.noComCompare, gap: isMobile ? '1.5rem' : '3rem', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center' }}>
                            <div style={{ ...s.noComBad, padding: isMobile ? '1.5rem 2rem' : '2rem 3rem' }} className="glass-effect">
                                <div style={s.noComBadTitle}>Plataformas de delivery</div>
                                <div style={{ ...s.noComBadStat, fontSize: isMobile ? '2.5rem' : '3.5rem' }}>−30%</div>
                                <div style={s.noComBadLabel}>por pedido</div>
                            </div>
                            <div style={s.noComVs}>vs</div>
                            <div className="glass-effect" style={{ ...s.noComGood, padding: isMobile ? '1.5rem 2rem' : '2rem 3rem', background: 'rgba(59,130,246,0.1)', border: '1px solid var(--primary)' }}>
                                <div style={s.noComGoodTitle}>Conexo POS</div>
                                <div style={{ ...s.noComGoodStat, fontSize: isMobile ? '2.5rem' : '3.5rem' }}>0%</div>
                                <div style={s.noComGoodLabel}>comisión</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── SOPORTE ── */}
            <section style={{ padding: '4rem 1.25rem', textAlign: 'center', borderTop: '1px solid var(--border-soft)' }}>
                <div style={s.container}>
                    <h2 style={{ color: '#fff', fontWeight: '800', marginBottom: '1rem' }}>Soporte Humano</h2>
                    <p style={{ color: 'var(--text-soft)' }}>No somos una IA de soporte. Tienes a nuestro equipo disponible vía Email y WhatsApp para lo que necesites.</p>
                </div>
            </section>

            {/* ── CTA FINAL ── */}
            <section style={{ ...s.ctaSection, padding: isMobile ? '5rem 1.25rem' : '8rem 1.5rem' }}>
                <div style={s.ctaContent}>
                    <h2 style={{ ...s.ctaTitle, fontSize: isMobile ? '2rem' : '3rem' }}>¿Listo para tomar el control?</h2>
                    <p style={{ ...s.ctaSub, fontSize: isMobile ? '1rem' : '1.25rem' }}>Empieza hoy. 7 días de prueba gratuita. Sin tarjeta de crédito.</p>
                    <div style={{ ...s.ctaBtns, flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'stretch' : 'center' }}>
                        <button id="cta-final-demo" onClick={() => navigate("/demo")} className="btn-premium" style={{ background: 'rgba(255,255,255,0.05)', color: 'white', border: '1px solid var(--border-soft)' }}>
                            Ver demo primero
                        </button>
                        <button id="cta-final-start" onClick={() => navigate("/onboarding")} className="btn-premium">
                            Crear mi restaurante gratis →
                        </button>
                    </div>
                </div>
            </section>

            {/* ── FOOTER ── */}
            <footer style={{ ...s.footer, padding: isMobile ? '2.5rem 1.25rem' : '4rem 1.5rem' }}>
                <div style={{ ...s.footerInner, flexDirection: isMobile ? 'column' : 'row', textAlign: isMobile ? 'center' : 'left', gap: isMobile ? '1.5rem' : '2rem' }}>
                    <Logo size={20} />
                    <div style={{ ...s.footerLinks, gap: isMobile ? '1.5rem' : '3rem', flexWrap: 'wrap', justifyContent: isMobile ? 'center' : 'flex-start' }}>
                        <a href="/onboarding" style={s.footerLink}>Crear restaurante</a>
                        <a href="/demo" style={s.footerLink}>Demo</a>
                        <a href="/terminos-de-uso" style={s.footerLink}>Términos</a>
                        <a href="/politica-privacidad" style={s.footerLink}>Privacidad</a>
                        <a href="/politica-cookies" style={s.footerLink}>Cookies</a>
                    </div>
                    <p style={s.footerCopy}>
                        © {new Date().getFullYear()} Conexo POS · conexopos.com
                    </p>
                </div>
                <p style={s.footerAdmin}>
                    <a href="/superadmin/login" style={s.footerAdminLink}>SuperAdmin</a>
                </p>
            </footer>
        </div>
    );
}

const s = {
    root: { background: "transparent", minHeight: "100vh", fontFamily: "var(--font-main, 'Inter', sans-serif)", color: "var(--text-main)" },
    // Nav
    nav: { position: "sticky", top: 0, zIndex: 100, background: "rgba(2,6,23,0.9)", backdropFilter: "blur(20px)", borderBottom: "1px solid var(--border-soft)" },
    navInner: { maxWidth: "1200px", margin: "0 auto", padding: "0 1.25rem", display: "flex", alignItems: "center", height: "64px", gap: "2rem" },
    navLinks: { display: "flex", gap: "2rem", flex: 1 },
    navLink: { color: "var(--text-soft)", textDecoration: "none", fontSize: "0.95rem", fontWeight: "500" },
    navActions: { display: "flex", gap: "0.75rem" },
    // Hero
    hero: { position: "relative", overflow: "hidden", maxWidth: "1200px", margin: "0 auto", display: "flex", alignItems: "center" },
    heroGlow: { position: "absolute", top: "-10%", left: "-10%", width: "600px", height: "600px", background: `radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)`, pointerEvents: "none" },
    heroContent: { flex: 1, zIndex: 1 },
    heroBadge: { display: "inline-block", background: "rgba(245,158,11,0.1)", border: `1px solid rgba(245,158,11,0.2)`, color: "var(--accent)", fontSize: "0.78rem", fontWeight: "700", padding: "0.4rem 1rem", borderRadius: "9999px", marginBottom: "1.5rem" },
    heroTitle: { fontWeight: "900", lineHeight: 1.1, margin: "0 0 1.25rem", color: "#fff", letterSpacing: "-0.04em" },
    heroAccent: { background: `linear-gradient(135deg, var(--primary), var(--secondary))`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
    heroSub: { color: "var(--text-soft)", lineHeight: 1.8, margin: "0 0 2rem", maxWidth: "600px" },
    heroCtas: { display: "flex", gap: "1rem", flexWrap: "wrap", marginBottom: "1rem" },
    heroNote: { color: "#475569", fontSize: "0.82rem" },
    // Mock
    heroMock: { flexShrink: 0, width: "420px", background: "rgba(30,41,59,0.4)", overflow: "hidden", borderRadius: "1rem" },
    mockBar: { background: "rgba(255,255,255,0.05)", padding: "0.75rem 1rem", display: "flex", alignItems: "center", gap: "0.5rem" },
    dot: { width: "12px", height: "12px", borderRadius: "50%", background: "#ef4444", display: "inline-block" },
    mockTitle: { flex: 1, textAlign: "center", fontSize: "0.75rem", color: "#475569", fontWeight: "600" },
    mockBody: { display: "flex", height: "240px" },
    mockSidebar: { width: "120px", borderRight: "1px solid var(--border-soft)", padding: "1rem 0" },
    mockItem: { padding: "0.6rem 1rem", fontSize: "0.8rem", color: "var(--text-soft)" },
    mockItemActive: { background: `rgba(59,130,246,0.1)`, color: "var(--primary)", borderRight: `3px solid var(--primary)` },
    mockContent: { flex: 1, padding: "1.25rem", display: "flex", flexDirection: "column", gap: "1rem" },
    mockCard: { borderRadius: "0.75rem", padding: "1rem" },
    mockStat: { fontSize: "1.5rem", fontWeight: "800" },
    mockLabel: { fontSize: "0.75rem", color: "var(--text-soft)", marginTop: "0.25rem" },
    // Promises
    promisesSection: { background: "rgba(15,23,42,0.5)", borderTop: `1px solid var(--border-soft)`, borderBottom: `1px solid var(--border-soft)`, padding: "3rem 1.25rem" },
    container: { maxWidth: "1100px", margin: "0 auto" },
    promisesGrid: { display: "grid" },
    promiseCard: { textAlign: "center" },
    promiseStat: { fontWeight: "900", color: "var(--primary)", letterSpacing: "-0.02em" },
    promiseLabel: { color: "var(--text-soft)", fontWeight: "500", marginTop: "0.5rem" },
    // Section
    section: { padding: "5rem 1.25rem", background: "var(--bg-main)" },
    sectionHeader: { textAlign: "center", marginBottom: "3rem" },
    pill: { display: "inline-block", background: "rgba(245,158,11,0.1)", border: "1px solid rgba(245,158,11,0.2)", color: "var(--accent)", fontSize: "0.82rem", fontWeight: "700", borderRadius: "9999px", padding: "0.3rem 1rem", marginBottom: "1.25rem" },
    sectionTitle: { color: "#fff", fontWeight: "800", margin: "0 0 0.5rem", letterSpacing: "-0.03em" },
    // Problem
    problemGrid: { display: "grid", gap: "1.25rem" },
    problemCard: { padding: "1.75rem", display: "flex", gap: "1rem", alignItems: "flex-start" },
    problemIcon: { fontSize: "1.75rem", flexShrink: 0 },
    problemText: { color: "var(--text-soft)", fontSize: "1rem", lineHeight: 1.6, margin: 0 },
    // Solution
    solutionGrid: { display: "grid", gap: "1.25rem" },
    solutionCard: { padding: "2rem" },
    solutionIcon: { fontSize: "2rem", marginBottom: "1rem" },
    solutionTitle: { color: "#fff", fontWeight: "700", margin: "0 0 0.5rem", fontSize: "1.15rem" },
    solutionDesc: { color: "var(--text-soft)", fontSize: "0.95rem", lineHeight: 1.7, margin: 0 },
    // No commissions
    noComSection: { background: "var(--bg-deep)" },
    noComCard: { textAlign: "center", maxWidth: "900px", margin: "0 auto" },
    noComTitle: { color: "#fff", fontWeight: "800", margin: "0 0 1rem" },
    noComSub: { color: "var(--text-soft)", margin: "0 0 2.5rem" },
    noComCompare: { display: "flex", justifyContent: "center", flexWrap: "wrap" },
    noComBad: { borderRadius: "1.5rem", textAlign: "center", background: "rgba(239,68,68,0.05)" },
    noComBadTitle: { color: "#f87171", fontSize: "0.9rem", marginBottom: "0.75rem", fontWeight: "600" },
    noComBadStat: { color: "#ef4444", fontWeight: "900" },
    noComBadLabel: { color: "#64748b", fontSize: "0.85rem" },
    noComVs: { color: "#475569", fontWeight: "800", fontSize: "1.5rem" },
    noComGood: { borderRadius: "1.5rem", textAlign: "center" },
    noComGoodTitle: { color: "var(--primary)", fontSize: "0.9rem", marginBottom: "0.75rem", fontWeight: "600" },
    noComGoodStat: { color: "#34d399", fontWeight: "900" },
    noComGoodLabel: { color: "#64748b", fontSize: "0.85rem" },
    // CTA Final
    ctaSection: { background: `radial-gradient(circle at center, rgba(59,130,246,0.1), transparent 70%)`, textAlign: "center" },
    ctaContent: { maxWidth: "800px", margin: "0 auto" },
    ctaTitle: { color: "#fff", fontWeight: "900", margin: "0 0 1rem", letterSpacing: "-0.04em" },
    ctaSub: { color: "var(--text-soft)", margin: "0 0 2.5rem" },
    ctaBtns: { display: "flex", gap: "1.25rem", justifyContent: "center", flexWrap: "wrap" },
    // Footer
    footer: { borderTop: "1px solid var(--border-soft)", background: "var(--bg-deep)" },
    footerInner: { maxWidth: "1200px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" },
    footerLinks: { display: "flex" },
    footerLink: { color: "#64748b", textDecoration: "none", fontSize: "0.85rem" },
    footerCopy: { color: "#334155", fontSize: "0.78rem", margin: 0 },
    footerAdmin: { textAlign: "center", marginTop: "0.5rem", fontSize: "0.72rem" },
    footerAdminLink: { color: "#1e293b", textDecoration: "none" },
};
